// TODO: [1] review use of peer dependencies vs dependencies
// TODO: [1] Tests for helpers
import React from 'react';
import PropTypes from 'prop-types';
import { Cardo } from '@cotyorg/ccx-organism-cardo';
import R from 'ramda';
import { getCardoConfig } from '../shared/helpers';
import HalfCardo from '../shared/HalfCardo';
import ThirdCardo from '../shared/ThirdCardo';
import QuarterCardo from '../shared/QuarterCardo';

const CardoGroup = ({
  currentBreakpoint,
  data,
  baseBreakpointConfig,
  everyNthBreakpointConfig,
  ...rest
}) => {
  if (!currentBreakpoint || !Array.isArray(data)) {
    // Prevent error being thrown when no breakpoint is provided
    // TODO: can this be removed after rebase for !currentBreakpoint (not Array.isArray check)
    return null;
  }

  return data.map((cardoData, index) => {
    if (
      !everyNthBreakpointConfig
      || (Array.isArray(everyNthBreakpointConfig) && everyNthBreakpointConfig.length < 2)
      || (Array.isArray(everyNthBreakpointConfig) && everyNthBreakpointConfig.length > 4)
    ) {
      // eslint-disable-next-line no-console
      console.warn([
        'CardoGroup should be supplied with 2-4 breakpoint configs.',
        'Since it was not, everyNthBreakpointConfig will be ignored.',
      ].join(''));

      return (
        <Cardo
          key={R.prop('id', cardoData)}
          data={cardoData}
          {...getCardoConfig({ baseBreakpointConfig })}
          currentBreakpoint={currentBreakpoint}
          {...rest}
        />
      );
    }

    if (everyNthBreakpointConfig.length === 2) {
      return (
        <HalfCardo
          key={R.prop('id', cardoData)}
          index={index}
          cardoData={cardoData}
          currentBreakpoint={currentBreakpoint}
          baseBreakpointConfig={baseBreakpointConfig}
          everyNthBreakpointConfig={everyNthBreakpointConfig}
          {...rest}
        />
      );
    }

    if (everyNthBreakpointConfig.length === 3) {
      return (
        <ThirdCardo
          key={R.prop('id', cardoData)}
          index={index}
          cardoData={cardoData}
          currentBreakpoint={currentBreakpoint}
          baseBreakpointConfig={baseBreakpointConfig}
          everyNthBreakpointConfig={everyNthBreakpointConfig}
          {...rest}
        />
      );
    }

    // everyNthBreakpointConfig.length === 4
    return (
      <QuarterCardo
        key={R.prop('id', cardoData)}
        index={index}
        cardoData={cardoData}
        currentBreakpoint={currentBreakpoint}
        baseBreakpointConfig={baseBreakpointConfig}
        everyNthBreakpointConfig={everyNthBreakpointConfig}
        {...rest}
      />
    );
  });
};

CardoGroup.propTypes = {
  currentBreakpoint: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object),
  baseBreakpointConfig: PropTypes.objectOf(PropTypes.object),
  everyNthBreakpointConfig: PropTypes.arrayOf(PropTypes.object),
};

export default CardoGroup;
